import { color } from "./color";
import { flex } from "./flex";
import { button } from "./button";
import { form } from "./form";
import { general } from "./general";
import { panel } from "./panel";

export const styles = { color, flex, button, form, general, panel };
